import { CodeBlock, railscast } from "react-code-blocks";
import styles from "./App.module.scss";

function App() {
  return (
    <div className={styles.App}>
      <h1 className={styles.title}>
        Get your loved ones an easy way to support you
      </h1>
      <div className={styles.codeBlock}>
        <span className={styles.instruction}>
          Copy and paste the link tag into your <code>&lt;head&gt;</code> tag.
        </span>
        <CodeBlock
          text={`<link rel="stylesheet" href="https://soltip-widget.vercel.app/static/css/soltip-widget.css"/>`}
          language="html"
          theme={railscast}
          showLineNumbers={false}
        />
      </div>
      <div className={styles.codeBlock}>
        <span className={styles.instruction}>
          Copy and paste the div into your
          <code>&lt;body&gt;</code> tag, and replace the <b>owner-address</b> with
          your own solana wallet address
        </span>
        <CodeBlock
          text={`<div id="soltip-widget" owner-address="zFys86e8C1du5uennzuGEoNYMigAgyj9F1PC6vdZu5U"></div>`}
          language="html"
          theme={railscast}
          showLineNumbers={false}
        />
      </div>
      <div className={styles.codeBlock}>
        <span className={styles.instruction}>
          Copy and paste these scripts into the bottom of your{" "}
          <code>&lt;body&gt;</code> tag.
        </span>
        <CodeBlock
          text={`<script src="https://soltip-widget.vercel.app/static/js/soltip-widget.js"></script>`}
          language="html"
          theme={railscast}
          showLineNumbers={false}
        />
      </div>
    </div>
  );
}

export default App;
